class BirdController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'parseBool'

	integrationId: 'bird'

	save: ->
		super(@configuration)
			.then (response) =>
				@configuration = response.data

	afterDisconnect: ->
		@configuration = {}

	validateEvents: ->
		for own eventName, enabled of @configuration.events
			if @parseBool(enabled)
				return true

		return false
